export default "__VITE_ASSET__CG9W0b3q__"